export default "__VITE_ASSET__BkWPJaNw__"